import React from 'react';
import {
  Lightbulb, ShieldCheck, HeartHandshake, CreditCard, FileSearch,
  Globe2, Lock, BookOpen, Sparkles,
} from 'lucide-react';

const services = [
  { title: 'RiskFree Suggestion', desc: 'We suggest the best plan among all companies based on your unique needs.', icon: Lightbulb, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { title: 'RiskFree Solution', desc: 'We help you pick the right insurance policies tailored to your profile.', icon: ShieldCheck, color: 'text-teal-600', bg: 'bg-teal-50' },
  { title: 'RiskFree Claim Support', desc: 'We provide support from filing to final settlement of every claim.', icon: HeartHandshake, color: 'text-orange-600', bg: 'bg-orange-50' },
  { title: 'RiskFree Payment', desc: 'Accept online transactions via PhonePe, GPay, Credit Card and UPI.', icon: CreditCard, color: 'text-blue-600', bg: 'bg-blue-50' },
  { title: 'RiskFree Quotation', desc: 'Best quotation among all partner companies — compared, side-by-side.', icon: FileSearch, color: 'text-purple-600', bg: 'bg-purple-50' },
  { title: 'RiskFree Online Service', desc: 'Everything done online — no need to visit the office for any step.', icon: Globe2, color: 'text-sky-600', bg: 'bg-sky-50' },
  { title: 'RiskFree Data Security', desc: 'We promise safe and secure handling of every detail you share with us.', icon: Lock, color: 'text-rose-600', bg: 'bg-rose-50' },
  { title: 'Understandable Terms', desc: 'We explain each & every term & condition in a clear, friendly manner.', icon: BookOpen, color: 'text-amber-600', bg: 'bg-amber-50' },
];

const WhyChooseUs = () => {
  return (
    <section className="bg-gradient-to-b from-white to-slate-50 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-1.5 rounded-full text-sm font-medium border border-emerald-100 mb-4">
            <Sparkles className="w-4 h-4" /> Why Choose Us
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A4B]">
            Our Best <span className="text-[#00B48E]">RiskFree</span> Services
          </h2>
          <p className="mt-3 text-slate-600 text-lg max-w-2xl mx-auto">
            Unbiased advice. Seamless claims. End-to-end support — from first quote to final settlement.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="group bg-white rounded-2xl border border-slate-100 p-6 hover:-translate-y-1 hover:shadow-lg hover:border-emerald-200 transition-all">
                <div className={`w-12 h-12 rounded-xl ${s.bg} ${s.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-[#0F2A4B] mb-2">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
